import { SxProps, Theme } from '@mui/material'

export const loadingWrapperSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '20rem',
}

export const paperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  background: 'transparent',
  padding: '4rem 2.4rem',

  '& > div:first-of-type': {
    borderTopLeftRadius: '2rem',
    borderBottomLeftRadius: '2rem',
  },

  '& > div:last-of-type': {
    borderTopRightRadius: '2rem',
    borderBottomRightRadius: '2rem',
  },
}

export const wrapperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  background: 'transparent',
  padding: { xs: '2.4rem', md: '3.2rem 5.7rem' },

  '& > div:first-of-type': {
    borderRadius: '2rem',
  },
}

export const promotionCodeAlertWrapperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  paddingTop: '2.4rem',
  marginX: { xs: '2.4rem', md: 0 },
}

export const availablePlansWrapperSx: SxProps<Theme> = {
  position: 'relative',
}

export const nextButtonSx: SxProps<Theme> = {
  color: (theme) => theme.palette.common.white,
  position: 'absolute',
  top: '16.1rem',
  right: '1.2rem',
  fontSize: '4.5rem',
}

export const backButtonSx: SxProps<Theme> = {
  color: (theme) => theme.palette.common.white,
  position: 'absolute',
  top: '16.1rem',
  left: '1.2rem',
  fontSize: '4.5rem',
}

export const mobileStepperSx: SxProps<Theme> = {
  position: 'absolute',
  top: '32.5rem',
  left: '50%',
  transform: 'translateX(-50%)',
  background: 'transparent',

  '.MuiMobileStepper-dots': {
    gap: '0.5rem',
  },

  '.MuiMobileStepper-dot': {
    backgroundColor: (theme) => theme.palette.background.paper,
    opacity: 0.2,
  },

  '.MuiMobileStepper-dotActive': {
    backgroundColor: (theme) => theme.palette.background.paper,
    opacity: 1,
  },
}
